<template>
  <div v-if="disclaimer.title" class="fee-transparency">
    <Message :title="disclaimer.title">
      <template #description>
        <BaseText size="sm">
          <template v-for="content in disclaimer.content">
            <template v-if="content.type === ContentHTMLTags.SPAN">{{
              content.text
            }}</template>
            <template v-else-if="content.type === ContentHTMLTags.LINK">
              <Link
                :key="content.text"
                :href="content.link"
                target="_blank"
                rel="noopener noreferrer"
                >{{ content.text }}</Link
              >
            </template>
          </template>
        </BaseText>
      </template>
    </Message>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { ContentHTMLTags, FeeTransparencyDisclaimer } from './types';
import { getFeeTransparencyDisclaimer } from '@/modules/trade/services/fee-transparency-disclaimer';
import {
  BaseText,
  Link,
  MessageFoundation as Message
} from '@warrenbrasil/nebraska-web';

const disclaimer = ref<FeeTransparencyDisclaimer>({
  title: '',
  content: []
});

onMounted(async () => {
  disclaimer.value = await getFeeTransparencyDisclaimer();
});
</script>
<style scoped lang="less">
.fee-transparency {
  margin-top: @size-spacing-x400;
}
.link {
  color: @element-secondary;
}
</style>
